export type IGetTimeDiff = Record<
  | 'years'
  | 'months'
  | 'days'
  | 'hours'
  | 'minutes'
  | 'seconds'
  , number
>;


export function getTimeDiff(startDate?: Date, endDate = new Date()): IGetTimeDiff | undefined {
  if (typeof startDate?.getMonth !== 'function' || typeof endDate?.getMonth !== 'function')
    return;

  const diff = Number(endDate) - Number(startDate);
  // const date = new Date

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30); // ~30
  const years = Math.floor(days / 365); // ~365

  return {
    years,
    months: months % 12,
    days: days % 30,
    hours: hours % 24,
    minutes: minutes % 60,
    seconds: seconds % 60
  };
}

export function getTimeDiffString({
  startDate = new Date(),
  endDate = new Date(),
  isDescription = false,
  isAccuracy = false,
}): string {
  const diffObj = getTimeDiff(startDate, endDate);
  const isFuture = +endDate > (+new Date() + 100);

  const feature = isDescription && isFuture
    ? 'через '
    : '';    
  const late = isDescription && !isFuture
    ? ' назад'
    : '';

  return !diffObj
    ? ''
    : isAccuracy
      ? `${feature}`
        + `${diffObj?.years ? ` ${diffObj.years} years` : ''}`
        + `${diffObj?.months ? ` ${diffObj.months} months` : ''}`
        + `${diffObj?.days ? ` ${diffObj.days} days` : ''}`
        + `${diffObj?.hours ? ` ${diffObj.hours} h` : ''}`
        + `${diffObj?.minutes ? ` ${diffObj.minutes} min` : ''}`
        + `${diffObj?.seconds ? ` ${diffObj.seconds} sec` : ''}`
        + `${late}
      `
      : (
        ((diffObj?.years || diffObj?.months) && (isFuture ? 'not soon' : 'long ago'))
        || diffObj?.days && `${feature}${diffObj?.days} d.${late}`
        || diffObj?.hours && `${feature}${diffObj?.hours} h.${late}`
        || diffObj?.minutes && `${feature}${diffObj?.minutes} min.${late}`
        || (isFuture ? 'now' : 'right now')
      )
}